import moment from 'moment';
import 'moment/locale/ja';
import { useEffect, useLayoutEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import { useRtoaster } from '../../../hooks/useRtoaster';
import messageConst from '../../../const/messageConst';
import common from "../../../resources/js/common/common";
import { PlanCount } from "../../atoms/planCount";
import { BreadCrumb } from '../../molecules/breadCrumb';
import { ErrorMassage } from "../../molecules/errorMassage";
import { LabelInputForm } from "../../molecules/labelInputForm";
import { ModalOptionForm } from '../../molecules/modalOptionForm';
import { PlanList } from "../../molecules/planList";
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import SideSearchFormContainer from "../hotel/sideSearchFormContainer";
import { MembershipPlanTitleContainer } from './membershipPlanTitleContainer';

import { apiKeyCheck, versionGetApi, getAvailablePlan } from "../../../const";
import commonUtil from '../../../common/commonUtil';
import { Loading } from '../../molecules/loading';

const MembershipSearchResultContainer = (props) => {
    const {
        login,
        state,
        setLoginType,
        membershipFacility,
        resvKaiinken,
        planConditions,
        grade,
        food,
        privilegedService,
        room,
        adultNum,
        childNum,

        keyWord,
        membershipSearchParam,
        setKeyWord,
        setPopupData,
        setPopupMessage,
        setMembershipReserveInfo,
        setMembershipSearchParam,
        setInputRoomList,
        setSelectKeiyakuNo,
        setOpenFacilityFlg,
        onClickOpenReservationPopupWindow,
        onClickOpenCheckListWindow,
        onClickOpenCalendarWindow,
        createAgeCountList,
        setMembershipResvStartDate } = props;

    const [flgList, setFlgList] = useState({});
    const loginType = login.loginType;
    const [loadingFlg, setLoadingFlg] = useState(false);
    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);

    const history = useHistory();
    const store = useStore();
    moment.locale('ja')

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [errFlgList, setErrFlgList] = useState({ errFacility: false, errPeopleNum: false, errAdultNum: false });

    // プラン一覧
    const [facilityList, setFacilityList] = useState([]);
    const [linkList, setLinkList] = useState([]);
    const [planNum, setPlanNum] = useState(0);

    // rtoasterタグ生成
    const customParam = {
        "riyosyodat": membershipSearchParam.checkInDate,
        "riyosaisyudat": membershipSearchParam.checkOutDate,
        "sisetucd": membershipSearchParam.shisetsuCdList?.length ? membershipSearchParam.shisetsuCdList.join(",") : "",
        "keiyakuno": membershipSearchParam.keiyakuNo,
        "packcategoryshosaicd01": membershipSearchParam.planConditionsCdList?.length ? membershipSearchParam.planConditionsCdList.join(",") : "",
        "packcategoryshosaicd02": membershipSearchParam.foodCdList?.length ? membershipSearchParam.foodCdList.join(",") : "",
        "roomsu": membershipSearchParam.roomCnt,
        "thanksflg": !!membershipSearchParam.privilegedServiceCdList?.length,
        "ninzu": membershipSearchParam.adultCnt + membershipSearchParam.childCnt,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        if (loginType === 'MEMBER') {
            setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/hotel/search", label: "ホテル予約" }]);
        } else if (loginType === 'CRAWL') {
            setLinkList([{ path: "/reserve/hotel/crawlSearch", label: "ホテル予約" }]);
        }
        // プラン一覧取得
        setLoadingFlg(true);
        common.doPost(getAvailablePlan, membershipSearchParam, afterGetAvailablePlan);

        // 部屋入力情報初期化
        setInputRoomList([]);
        // ログインタイプ取得
        setLoginType(loginType);
    }, [useMediaFlag]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const onChangeKeyWord = (e) => setKeyWord(e.target.value);

    // 検索後処理
    const afterGetAvailablePlan = (res) => {
        const data = res.data;
        // エラーが発生した場合はメッセージを表示
        let errMsg = null;
        if (data.resultCode != "0") {
            errMsg = messageConst.SEARCH_ERROR;
        }
        if (data.resultCode == "0" && (!data.shisetsuList || !data.shisetsuList.length)) {
            errMsg = messageConst.HOTEL_PLAN_NOT_FOUND_ERROR;
        }
        if (errMsg) {
            window.scroll({ top: 0, behavior: 'smooth' })
            setErrorInfo({ errorMessage: [errMsg], errorFlg: true, });
            setLoadingFlg(false);
            return;
        }
        // 検索時間設定
        setMembershipResvStartDate(commonUtil.getStringFromDate(new Date(), "yyyy-MM-dd"));
        handlePlanList(data.shisetsuList);
    }

    // プラン一覧取得
    const handlePlanList = (list) => {
        let planNum = 0;
        list.forEach(value => {
            planNum += value.planShohinList.length ?? 0;
        })
        setPlanNum(planNum);
        let newList = list.map(value => {
            let machiFlgS = null;
            let gradeNameS = null;
            let machiFlgE = null;
            let gradeNameE = null;
            let machiFlgC = null;
            let gradeNameC = null;
            let machiFlgA = null;
            let gradeNameA = null;
            if (value.planShohinList){
                value.planShohinList.forEach(planShohin => {
                    planShohin.planList.forEach(plan => {
                        if (plan.machiFlgS != null && machiFlgS != 0) {
                            machiFlgS = plan.machiFlgS
                            gradeNameS = plan.gradeNameS
                        }
                        if (plan.machiFlgE != null && machiFlgE != 0) {
                            machiFlgE = plan.machiFlgE
                            gradeNameE = plan.gradeNameE
                        }
                        if (plan.machiFlgC != null && machiFlgC != 0) {
                            machiFlgC = plan.machiFlgC
                            gradeNameC = plan.gradeNameC
                        }
                        if (plan.machiFlgA != null && machiFlgA != 0) {
                            machiFlgA = plan.machiFlgA
                            gradeNameA = plan.gradeNameA
                        }
                    })
                })

            }
            return {...value, machiFlgS, gradeNameS, machiFlgE, gradeNameE, machiFlgC, gradeNameC, machiFlgA, gradeNameA, }
        })
        setErrorInfo({ errorMessage: [], errorFlg: false, });
        setFacilityList(newList)
        setLoadingFlg(false);
        window.scroll({ top: 0, behavior: 'smooth' })
    }

    // プラン詳細ポップアップ
    const handlePlanDetail = (facility, planShohin, plan) => {
        let popupData = {
            honkanShisetsuCd: facility.honkanShisetsuCd,
            shisetsuCd: facility.shisetsuCd,
            shisetsuName: facility.shisetsuName,
            shisetsuImage: facility.shisetsuImage,
            generalFlg: facility.generalFlg,
            planShohinCd: planShohin.planShohinCd,
            planShohinName: planShohin.planShohinName,
            planCd: plan.planCd,
            planCategoryDetailCd: plan.planCategoryDetailCd,
            planName: plan.planName,
            machiFlg: plan.machiFlg,
            machiFlgA: plan.machiFlgA,
            machiFlgC: plan.machiFlgC,
            machiFlgE: plan.machiFlgE,
            machiFlgS: plan.machiFlgS,
            planDescription: plan.planDescription,
            dinnerTsukiPlanFlg: plan.dinnerTsukiPlanFlg,
            breakfastTsukiPlanFlg: plan.breakfastTsukiPlanFlg,
            planRyokinTotal: plan.planRyokinTotal,
            planRyokinAdult: plan.planRyokinAdult,
            planRyokinChild: plan.planRyokinChild,
            dinnerRyokinAdult: plan.dinnerRyokinAdult,
            thanksFlg: plan.thanksFlg,
            planTokuten: plan.planTokuten,
            planAnnaiUrl: plan.planAnnaiUrl,
            roomDescription: plan.roomDescription,
            teikyoStartDate: plan.courseTeikyoStartDate,
            teikyoEndDate: plan.courseTeikyoEndDate,
            menuName: plan.menuName,
            courseGazoURL: plan.courseGazoURL,
            courseNaiyoSetsumeibun1: plan.courseNaiyoSetsumeibun1,
            courseNaiyoSetsumeibun2: plan.courseNaiyoSetsumeibun2
            
        }
        setPopupData("プラン詳細", "planDetail", popupData);
    }

    // 検索条件保存
    const handleSaveSearchCondition = () => {
        // リクエスト作成
        // 施設
        let facilities = "";
        membershipFacility.membership.forEach((data) => {
            if (data.shisetsuList) {
                data.shisetsuList.forEach(item => {
                    if (item.checked) {
                        facilities = facilities + (facilities == "" ? "" : "\n");
                        facilities = facilities + item.value;
                    }
                })
            }
        });
        membershipFacility.ippan.forEach((data) => {
            if (data.shisetsuList) {
                data.shisetsuList.forEach(item => {
                    if (item.checked) {
                        facilities = facilities + (facilities == "" ? "" : "\n");
                        facilities = facilities + item.value;
                    }
                })
            }
        });
        // 1室あたりの人数
        let adults = 2;
        adultNum.forEach((data) => {
            if (data.selected === true) adults = parseInt(data.id);
        });
        let children = 0;
        childNum.forEach((data) => {
            if (data.selected === true) children = parseInt(data.id);
        });
        // 室数
        let rooms = 1;
        room.forEach((data) => {
            if (data.selected === true) rooms = parseInt(data.id);
        });
        // 会員権
        let kaiinkenId = "";
        for (var i in resvKaiinken) {
            if (resvKaiinken[i].selected === true) {
                kaiinkenId = resvKaiinken[i].id;
            }
        }
        // 詳細条件
        let detailConditions = "";
        // // グレード
        // grade.forEach((data) => {
        //     if (data.selected === true) {
        //         detailConditions = detailConditions + (detailConditions == "" ? "" : "\n");
        //         detailConditions = detailConditions + data.value;
        //     }
        // });
        // プラン条件
        planConditions.forEach((data) => {
            if (data.checked === true) {
                detailConditions = detailConditions + (detailConditions == "" ? "" : "\n");
                detailConditions = detailConditions + data.value;
            }
        });
        // 夕食
        food.forEach((data) => {
            if (data.checked === true) {
                detailConditions = detailConditions + (detailConditions == "" ? "" : "\n");
                detailConditions = detailConditions + data.value;
            }
        });
        // サービス権利
        privilegedService.forEach((data) => {
            if (data.checked === true) {
                detailConditions = detailConditions + (detailConditions == "" ? "" : "\n");
                detailConditions = detailConditions + data.value;
            }
        });
        let reqParam = {
            shisetsuData: login.memberCode,
            shisetsuData: facilities,
            numberOfAdult: Number(adults),
            numberOfChild: Number(children),
            numberOfRoom: rooms,
            detailedConditionsList: detailConditions
        }
        setPopupData("検索条件の保存", "saveFavorite", reqParam);
        setPopupMessage(messageConst.CONFIRM_SAVE_FAVORITE);
    }

    // 「予約する」ボタン押下
    const handleReserve = (facility, planShohin, plan) => {
        setMembershipSearchParam({
            ...membershipSearchParam,
            memberCd: resvKaiinken[0].memberCd,
        });

        setMembershipReserveInfo({
            honkanShisetsuCd: facility.honkanShisetsuCd,
            shisetsuCd: facility.shisetsuCd,
            shisetsuName: facility.shisetsuName,
            generalFlg: facility.generalFlg,
            planShohinCd: planShohin.planShohinCd,
            planCd: plan.planCd,
            planCategoryDetailCd: plan.planCategoryDetailCd,
            planName: plan.planName,
            machiFlg: plan.machiFlg,
            dinnerTsukiPlanFlg: plan.dinnerTsukiPlanFlg,
            breakfastTsukiPlanFlg: plan.breakfastTsukiPlanFlg,
            planRyokinTotal: plan.planRyokinTotal,
            planRyokinAdult: plan.planRyokinAdult,
            planRyokinChild: plan.planRyokinChild,
            dinnerRyokinAdult: plan.dinnerRyokinAdult,
            thanksFlg: plan.thanksFlg,
            planTokuten: plan.planTokuten,
            planAnnaiUrl: plan.planAnnaiUrl,
            changeFlg: false,
        });
        history.push("/reserve/hotel/inputUser");
    }
    // 常設待ち予約ボタン押下
    const handleReserveMachi = (facility, planShohin, plan) => {
        const checkInBaseDate = commonUtil.getDateFromString(facility.flKirikaeDat, "-");
        let checkOutBaseDate = new Date(checkInBaseDate);
        checkOutBaseDate.setDate(checkOutBaseDate.getDate() + 1);
        const result = commonUtil.getDateFromString(membershipSearchParam.checkInDate, "-") <= checkInBaseDate && commonUtil.getDateFromString(membershipSearchParam.checkOutDate, "-") <= checkOutBaseDate;
        const facilityMachiFlg = result ? "2" : "1";
        setMembershipSearchParam({
            ...membershipSearchParam,
            memberCd: resvKaiinken[0].memberCd,
        });
        setMembershipReserveInfo({
            honkanShisetsuCd: facility.honkanShisetsuCd,
            shisetsuCd: facility.shisetsuCd,
            shisetsuName: facility.shisetsuName,
            generalFlg: facility.generalFlg,
            planShohinCd: planShohin.planShohinCd,
            planCd: plan.planCd,
            planCategoryDetailCd: plan.planCategoryDetailCd,
            planName: plan.planName,
            machiFlg: facilityMachiFlg,
            dinnerTsukiPlanFlg: false,
            breakfastTsukiPlanFlg: false,
            planRyokinTotal: 0,
            planRyokinAdult: 0,
            planRyokinChild: 0,
            dinnerRyokinAdult: 0,
            thanksFlg: false,
            planTokuten: "",
            planAnnaiUrl: "",
            changeFlg: false,
        });
        history.push("/reserve/hotel/inputUser");
    }

    // 施設画像エラー時処理
    const handleErrorFacility = (index) => {
        let newFacilityList = [];
        facilityList.forEach((facility, facilityIndex) => {
            if (facilityIndex != index) {
                newFacilityList.push(facility);
            }
        })
        calcPlanNum(newFacilityList);
        setFacilityList(newFacilityList);
    }

    // プラン画像エラー時処理
    const handleErrorPlan = (shisetsuCd, planShohinCd) => {
        let newFacilityList = [];
        facilityList.forEach(facility => {
            if (facility.shisetsuCd == shisetsuCd) {
                if (facility.planShohinList) {
                    let newPlanShohinList = [];
                    facility.planShohinList.forEach((planShohin) => {
                        if (planShohin.planShohinCd != planShohinCd) {
                            newPlanShohinList.push(planShohin);
                        }
                    });
                    facility.planShohinList = newPlanShohinList;
                }
            }
            newFacilityList.push(facility);
        });
        calcPlanNum(newFacilityList);
        setFacilityList(newFacilityList);
    }

    // プラン件数計算
    const getPlanShohinCount = (planShohinList) => {
        let planShohinCount = planShohinList?.length;
        planShohinList?.forEach(planShohin => {
            if (planShohin.planList?.[0]?.machiFlg != "0") {
                planShohinCount--;
            }
        });
        return  planShohinCount;
    }

    // 料金表示
    const handleOpenFee = (facilityIndex, planShohinIndex) => {
        facilityList[facilityIndex]["planShohinList"][planShohinIndex]["openFlg"] = !facilityList[facilityIndex]["planShohinList"][planShohinIndex]["openFlg"];
        let newFacilityList = [];
        facilityList.forEach(value => {
            newFacilityList.push(value);
        });
        setFacilityList(newFacilityList);
    }

    // 該当プラン件数計算
    const calcPlanNum = (list) => {
        let count = 0;
        if (list) {
            list.forEach((facility) => {
                if (facility.planShohinList) {
                    facility.planShohinList.forEach(planShohin => {
                        if (planShohin.planList) {
                            planShohin.planList.forEach(plan => {
                                count++;
                            })
                        }
                    })
                }
            })
        }
        setPlanNum(count);
    }

    return (
        <div>
            {loadingFlg ?
                <Loading
                    width={50}
                    height={50}
                    type={"spin"}
                    color={"white"}
                    wrapperClass="membership_loading"
                /> : null
            }
            <MembershipPlanTitleContainer
                login={login}
                state={state}
                onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                handleSaveSearchCondition={handleSaveSearchCondition}
                handlePlanList={handlePlanList}
                createAgeCountList={createAgeCountList}
                setLoadingFlg={setLoadingFlg}
            />
            <div className={isWideTablet ? "reservationResultInnerWrapperSp" : "reservationResultInnerWrapper"}>
                <BreadCrumb
                    breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                    linkStyle={styles.link}
                    linkList={linkList}
                    lastLabel="検索結果"
                    lastLabelClassName="lastLabel"
                />
                <div className="searchResultMobilewrap">
                    <LabelInputForm
                        id="keyWord"
                        placeholder="例）ワイキキホテル"
                        value={keyWord}
                        className={flgList.errInputWord ? "popupButtonKeywordErr" : "popupButtonKeyword "}
                        onChange={onChangeKeyWord}
                        labelClassName="popupLabel"
                        wrapClassName="popupWrapLong"
                    />
                    <div className="resultSearchCondition">
                        <ModalOptionForm
                            wrapClassName="searchConditionWrap"
                            className="saveSearchConditionBtn"
                            onClick={handleSaveSearchCondition}
                            text="この検索条件を保存"
                        />
                        <ModalOptionForm
                            wrapClassName="searchConditionWrap"
                            className="searchConditionBtn"
                            onClick={() => onClickOpenReservationPopupWindow("savedSearch", login.memberCode)}
                            text={"保存した検索条件"}
                        />
                    </div>
                </div>
                <div style={styles.reservationResult}>
                    <div className={isWideTablet ? "hiddenItem" : "searchFormInnerWrapper"}>
                        <div className="searchFormWrapper">
                            <SideSearchFormContainer
                                state={state}
                                onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                                onClickOpenCheckListWindow={onClickOpenCheckListWindow}
                                onClickOpenCalendarWindow={onClickOpenCalendarWindow}
                                handlePlanList={handlePlanList}
                                setPopupData={setPopupData}
                                setPopupMessage={setPopupMessage}
                                handleSaveSearchCondition={handleSaveSearchCondition}
                                createAgeCountList={createAgeCountList}
                                setLoadingFlg={setLoadingFlg}
                                setSelectKeiyakuNo={setSelectKeiyakuNo}
                                setOpenFacilityFlg={setOpenFacilityFlg}
                            />
                        </div>
                    </div>
                    <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                        <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessage} />
                    </div>
                    <div className="planListInnerWrapper">
                        <PlanList
                            checkIn={membershipSearchParam.checkInDate}
                            checkOut={membershipSearchParam.checkOutDate}
                            membershipFacility={membershipFacility}
                            facilityList={facilityList}
                            facilityListWrapperName={"hotelListWrapper"}
                            planListWrapperName={"planListWrapper"}
                            planWrapperName={"planWrapper"}
                            planListStyle={styles.planList}
                            facilityImgStyle={styles.facilityImg}
                            handlePlanDetail={handlePlanDetail}
                            handleReserve={handleReserve}
                            handleReserveMachi={handleReserveMachi}
                            handleErrorFacility={handleErrorFacility}
                            handleErrorPlan={handleErrorPlan}
                            getPlanShohinCount={getPlanShohinCount}
                            isWideTablet={isWideTablet}
                            handleOpenFee={handleOpenFee}
                            crawlMachiFlg={membershipSearchParam?.crawlMachiFlg}
                        />
                    </div>
                </div>
                <div style={styles.description}>
                    ※サンメンバーズとザ・ロッジの客室タイプは、すべてが「スタンダード」タイプです。
                </div>
                <div className="backTopSearchResult">
                    <Link to={loginType === "MEMBER" ? "/reserve/hotel/search" : "/reserve/hotel/crawlSearch"} style={styles.bottomLink}>ホテル検索TOPへ戻る</Link>
                </div>
            </div>
            <div style={styles.footer}>
                <MembershipFooterContainer />
            </div>
        </div>

    );
};


const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        login: state.login,
        dispRoom: state.dispRoom,
        membershipSearchParam: state.membershipSearchParam,
        resvKaiinken: state.resvKaiinken,
        room: state.room,
        adultNum: state.adultNum,
        childNum: state.childNum,
        planConditions: state.planConditions,
        grade: state.grade,
        food: state.food,
        privilegedService: state.privilegedService,
        membershipFacility: state.membershipFacility,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setInputRoomList: (item) => {
            dispatch({ type: "INPUT_ROOM_LIST", payload: { inputRoomList: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
        setMembershipResvStartDate: (item) => {
            dispatch({ type: "MEMBERSHIP_RESV_START_DATE", payload: { membershipResvStartDate: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipSearchResultContainer);

const styles = {
    reservationResult: {
        display: "flex",
        width: "100%",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "gray",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "gray",
        marginBottom: "20px",
        paddingTop: "8px",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    planList: {
        width: "100%",
        paddingBottom: "30px"
    },
    facilityImg: {
        width: "100%"
    },
    footer: {
        width: "80%",
        padding: "30px 10%",
        whiteSpace: "nowrap",
        color: "white",
        fontWeight: "300",
    },
    errorMassage: {
        display: "inline-block",
        whiteSpace: "pre-line",
        textAlign: "center",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    description: {
        padding: "0 30px",
        letterSpacing: "1px",
        fontSize: "13px",
        color: "rgb(111 111 111)",
        margin: "0 5%",
    }
}
